import React, { Fragment, FunctionComponent } from 'react';
import { isArray } from '@/utils/isArray';
import { Col, Container, Row } from '@visalex/core';

import cx from 'clsx';

import { VisaPageKeyProblem } from '../../VisaPage';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

import styles from './KeyProblemsSection.module.scss';

type KeyProblemsProps = {
  title: string;
  subtitle: string;
  imageFirst: boolean;
  lastItemMdHorizontal: boolean;
  problemsList: VisaPageKeyProblem[];
};

const KeyProblemsSection: FunctionComponent<KeyProblemsProps> = ({
  title,
  subtitle,
  imageFirst,
  lastItemMdHorizontal,
  problemsList,
}) => {
  return (
    <section className={styles['visa-page__key-problems-section']}>
      <Container>
        <Row>
          <Col md={12} lg={8} className="text-align-left">
            <h2 className={styles['visa-page__title']}>{title}</h2>
            <p className={styles['visa-page__subtitle']}>{subtitle}</p>
          </Col>
        </Row>
        {isArray(problemsList) &&
          problemsList.map((problem, key) => {
            const isLast = lastItemMdHorizontal && problemsList.length === key + 1;
            const isEven = key % 2 === 0;
            const changeRowDirectionFlag = imageFirst ? !isEven : isEven;

            return (
              <Row
                key={key}
                className={cx(
                  styles['problem-item'],
                  changeRowDirectionFlag ? 'flex-md-row-reverse' : 'flex-md-row',
                  isLast ? styles['problem-item__last'] : 'flex-column'
                )}
              >
                <Col
                  key={`${key}_0`}
                  md={isLast ? 12 : 6}
                  lg={6}
                  className={cx(
                    styles['column-with-image'],
                    'position-relative d-flex justify-content-center',
                    changeRowDirectionFlag && 'offset-lg-1'
                  )}
                >
                  <ResponsiveImage
                    imageUrl={problem.imageUrl}
                    alt={problem.imageAlt}
                    imageName={problem.imageName}
                    className={cx(
                      styles['problem-item__image'],
                      !changeRowDirectionFlag && styles['image_aligned-right'],
                      changeRowDirectionFlag && styles['image_aligned-right_even']
                    )}
                  />
                </Col>
                <Col
                  key={`${key}_2`}
                  md={isLast ? 12 : 6}
                  lg={5}
                  className={cx(isLast && styles['problem-item__last-col'], !changeRowDirectionFlag && 'offset-lg-1')}
                >
                  <h4 className={styles['problem-item__title']}>{problem.title}</h4>
                  {problem.textParts.map((text, index) => (
                    <Fragment key={index}>
                      {Array.isArray(text) ? (
                        <div key={index}>
                          {text.map((textItem, itemIndex) => (
                            <p
                              className={styles['problem-item__text']}
                              key={itemIndex}
                              dangerouslySetInnerHTML={{
                                __html: textItem,
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        <p
                          className={cx(
                            styles['problem-item__text'],
                            index === 0 && styles['problem-item__text_first']
                          )}
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: text,
                          }}
                        />
                      )}
                    </Fragment>
                  ))}
                </Col>
              </Row>
            );
          })}
      </Container>
    </section>
  );
};

export default KeyProblemsSection;
